import { ReduxAction } from '../../types/common'
import { GET_CPTY } from '../actionTypes'

export interface Cpty {
  cptyId: number
  name: string
}

interface CptyState {
  cpty: Cpty[]
}

const INITIAL_STATE = {
  cpty: [],
}

export const cpty = (state: CptyState = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case GET_CPTY:
      return {
        ...state,
        cpty: action.payload as Cpty[],
      }
    default:
      return state
  }
}
